/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_SubtitleInputs */

const en_onboarding_rating_subtitle = /** @type {(inputs: Onboarding_Rating_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help us improve our app`)
};

const es_onboarding_rating_subtitle = /** @type {(inputs: Onboarding_Rating_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayúdanos a mejorar nuestra app`)
};

/**
* | output |
* | --- |
* | "Help us improve our app" |
*
* @param {Onboarding_Rating_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_subtitle = /** @type {((inputs?: Onboarding_Rating_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_subtitle(inputs)
	return en_onboarding_rating_subtitle(inputs)
});